import { UsersTable } from './components/UsersTable/UsersTable';
import { AdminUsersContext } from './model';
import {
  resolveOwnedDashboardContext,
  ShigoDashboardContext,
} from '../../auth/dashboardDestination';
import { useShigoSession } from '../../../lib/useShigoSession';

export function UsersPage() {
  const { session } = useShigoSession();
  const context =
    session && resolveOwnedDashboardContext(session.user) === ShigoDashboardContext.SuperAdmin
      ? AdminUsersContext.SuperAdmin
      : AdminUsersContext.Main;

  return <UsersTable context={context} />;
}
